export default __webpack_public_path__ + "static/media/radio-active.fe90c5d6.svg";